import tw, { styled } from 'twin.macro';

const TwoThirdsLayout = styled.div`
  ${tw`w-2/3 flex-none`}
`;

export default TwoThirdsLayout;
